/** JSON-LD in HTML: escape `<` so `</script>` in copy cannot truncate the block (#1153). */
export function serializeJsonLd(schema: unknown): string {
  return JSON.stringify(schema).replace(/</g, '\\u003c');
}
